import React from 'react';
import ReactDOM from 'react-dom/client'; // Importing createRoot from ReactDOM for React 18+
import './index.css'; // Global styles
import App from './App'; // Main App component
import { I18nextProvider } from 'react-i18next'; // i18next provider for localization
import i18n from './i18n'; // Your i18n configuration

// Get the root element from the DOM
const container = document.getElementById('root');

// Create the root using ReactDOM's createRoot method
const root = ReactDOM.createRoot(container);

// Render the application inside StrictMode, wrapped with I18nextProvider for internationalization support
root.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <App />
    </I18nextProvider>
  </React.StrictMode>
);
